module.exports = __webpack_public_path__ + "static/img/4.0126d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gczp/images/4.png
// module id = tAI2
// module chunks = 1